/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import PrivacyLawFirmPageMeta from "./PrivacyLawFirmPageMeta";
import Container from "../../../../components/Container/Container";
import Layout from "../../../Layouts/Layout";
import PrivacyLawFirm from "../../../../components/Privacy/PrivacyLawFirm/PrivacyLawFirm";

const PrivacyLawFirmPage = () => {
  return (
    <Layout backgroundType={"landingpage"}>
      <PrivacyLawFirmPageMeta />
      <Container sectionPadding={false}>
        <PrivacyLawFirm />
      </Container>
    </Layout>
  );
};

export default PrivacyLawFirmPage;
